import type React from "react";
import PersistentLayout from "@/layouts/persistent-layout";
import type { BizminerPillarInsight } from "@/types/serializers";
import FunctionalInsightLayout from "./_components/FunctionalInsightLayout";

interface PageWithProps extends React.ReactElement {
  props: {
    pillar_insight: BizminerPillarInsight;
    category_id: string;
    current_tab: string;
  };
}

/**
 * Layout wrapper for the tabbed content of our functional insights components.
 * This allows to use inertia's persistent layout which prefents flickering of the included
 * chart at the top.
 */
export function withFunctionalInsightLayout(page: PageWithProps) {
  const { pillar_insight, category_id, current_tab } = page.props;
  return (
    <PersistentLayout>
      <FunctionalInsightLayout
        pillar_insight={pillar_insight}
        category_id={category_id}
        current_tab={current_tab}
      >
        {page}
      </FunctionalInsightLayout>
    </PersistentLayout>
  );
}
